import { TableColumnPopupType } from "../Components/Popup/TableColumnPopup"
import { getLocalisedText } from "../Translate/LanguageManager"

export default class AdditionalChargeParser {
    static getAdditionalCharge(dataFromAPI, returnData) {
        var additionalFooterData = []
        if (dataFromAPI.additionalCharges !== undefined && dataFromAPI.additionalCharges !== null) {
            if (dataFromAPI.additionalCharges.globalDiscounts && dataFromAPI.additionalCharges.globalDiscounts.length > 0) {
                dataFromAPI.additionalCharges.globalDiscounts.forEach(element => {
                    additionalFooterData.push(this.setFooterObject(TableColumnPopupType.globalDiscount, element.name, element.amount, 'parent'));
                });
            } else {
                if (dataFromAPI.additionalCharges.globalDiscount !== undefined) {
                    if (dataFromAPI.additionalCharges.globalDiscount.amount > 0) {
                        var name = getLocalisedText('pre_tax')
                        if (!dataFromAPI.additionalCharges.globalDiscount.isSubTotalOnly) {
                            name = getLocalisedText('post_tax')
                        }

                        let label = getLocalisedText('global_discount') + ' (' + name + ')'
                        if (dataFromAPI.additionalCharges.globalDiscount.isPercent) {
                            label = label + ' (' + dataFromAPI.additionalCharges.globalDiscount.percent + '%) '
                            additionalFooterData.push(this.setFooterObject(TableColumnPopupType.globalDiscount, label, dataFromAPI.additionalCharges.globalDiscount.amount, 'parent'))
                        }
                        else {
                            additionalFooterData.push(this.setFooterObject(TableColumnPopupType.globalDiscount, label, dataFromAPI.additionalCharges.globalDiscount.amount, 'parent'))
                        }
                    }
                }
            }

            if (dataFromAPI.additionalCharges.additionalChargesDetails !== undefined && dataFromAPI.additionalCharges.additionalChargesDetails !== null) {
                if (dataFromAPI.additionalCharges.additionalChargesDetails.length > 0) {
                    dataFromAPI.additionalCharges.additionalChargesDetails.forEach(element => {
                        var taxLabel = element.additionalCharge
                        var taxCodeLabel = element.additionalCharge

                        additionalFooterData.push(this.setFooterObject(element.additionalCharge, taxLabel, element.chargeAmount, 'parent'))

                        var taxList = ['igst', 'cgst', 'sgst']
                        taxList.forEach(taxName => {
                            var inTax = this.getAdditionalChargeTax(element, taxName)
                            if (inTax !== undefined) {
                                additionalFooterData.push(inTax)
                            }
                        });

                        if (element.taxAmount > 0) {
                            if (element.addtionalChargeTax !== undefined && element.addtionalChargeTax !== null) {
                                if (element.addtionalChargeTax !== '') {
                                    taxCodeLabel = taxLabel + ' (' + element.addtionalChargeTax + ")"
                                }
                            }
                            additionalFooterData.push(this.setFooterObject(taxCodeLabel, taxCodeLabel, element.taxAmount, 'parent_tax'))
                        }
                    });
                }
            }
        }

        if (additionalFooterData.length === 1) {
            if (additionalFooterData[0].taxId === TableColumnPopupType.globalDiscount) {
                if (additionalFooterData[0].taxAmount === 0) {
                    additionalFooterData = []
                }
            }
        }

        returnData.additionalCharge = additionalFooterData
        return returnData
    }

    static setFooterObject(id, label, amount, taxType) {
        return {
            "taxId": id,
            "taxName": label,
            "taxAmount": amount,
            "taxType": taxType,
        }
    }

    static getAdditionalChargeTax(additionalCharges, taxObject) {
        var item = undefined
        if (additionalCharges[taxObject] !== undefined && additionalCharges[taxObject] !== null) {
            if (additionalCharges[taxObject] !== 0) {
                var taxLabel = additionalCharges.additionalCharge + ' (' + taxObject.toUpperCase() + ')'
                item = this.setFooterObject(additionalCharges.additionalCharge + '_' + taxObject, taxLabel, additionalCharges[taxObject], 'gst')
            }
        }
        return item
    }
}

